import { defineComponent } from 'vue'

import MsLightbox from '../MsLightbox/MsLightbox.vue'

export default defineComponent({
    name: 'MsDetailThreeSixtyLightbox',
    components: {
        MsLightbox,
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        iFrameUrl: {
            type: String,
            required: true,
        },
    },
    emits: ['closeLightbox'],
    setup(props, { emit }) {
        function emitClosedLightboxEvent() {
            emit('closeLightbox')
        }

        return {
            emitClosedLightboxEvent,
        }
    },
})
